import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/services/FacadeService';
import { LoginRequest, User } from 'src/models';
import { login } from '../../store/user/user.action';

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.less']
})
export class LoginDialogComponent implements OnInit {
  loginRequest: LoginRequest;
  showSpinner: boolean;
  showError: boolean;
  errorMessage: '';
  validEmailAddress: RegExp;
  showForgotPassword: boolean;
  emailSent: boolean;

  constructor(private service: FacadeService, public dialogRef: MatDialogRef<LoginDialogComponent>, private store: Store<{}> ) { };

  ngOnInit(): void {
    this.loginRequest = new LoginRequest();
    this.validEmailAddress= /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;    
  }
  

  onLogin() {
   if(!this.showForgotPassword){
    if(!this.loginRequest.userName || !this.loginRequest.password || !this.hasValidEmailAddress){
      this.showError = true;
      return;
    }

    this.showSpinner = true;
    this.service.productService.Login(this.loginRequest).then(data => {  
      const resp = data as any;
      if(resp.success) {
        const u = {...resp.user, isLoggedIn: true}
        this.store.dispatch(login({user: u}));
        this.dialogRef.close(true);
      }else {
        this.errorMessage = resp.errorMessage;
        this.showSpinner = false;
      }
    
   })
   }
   else {
    if(!this.hasValidEmailAddress){
      this.showError = true;
      return;
    }
    this.showSpinner = true;
    this.service.productService.ResetPassword(this.loginRequest).then(data => {
      this.emailSent = true;
    });
   }
  }

  onClose() {
    this.dialogRef.close();
  }

  onResetPasswordClick() {
    this.showForgotPassword = true;
  }

  onRegister() {
    this.dialogRef.close({register: true});
  }

  get hasValidEmailAddress() {
    return this.loginRequest.userName.match(this.validEmailAddress);
  }

}
